module.exports = __webpack_public_path__ + "img/patient-info-mobile-ru.fb9bc7b2.jpg";